import { render, staticRenderFns } from "./DashboardTab.vue?vue&type=template&id=e6421f0c&scoped=true"
import script from "./DashboardTab.vue?vue&type=script&lang=js"
export * from "./DashboardTab.vue?vue&type=script&lang=js"
import style0 from "./DashboardTab.vue?vue&type=style&index=0&id=e6421f0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6421f0c",
  null
  
)

export default component.exports